import Layout from '../../Components/layout/Layout';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { FaStar } from 'react-icons/fa6';
import { FaArrowDownLong } from 'react-icons/fa6';
import React, { useEffect, useState } from 'react';
// import ProcedurePrev from "./Procedure model component/ProcedurePrev";
import Button from '../../Components/Butten/Button';
// import Pinkbtn from "../Butten/Pinkbtn";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  CreateProcedureSuccess,
  RequestOfCreatingProcedure,
  CreateProcedureFailed,
  ResetProcedure,
  ProcedureUpdateSuccess,
} from '../../Redux/ProcedureReducer';
import { api } from '../../Api-Endpoints/apiEndpoint';
import toast from 'react-hot-toast';
import Step from '../../Components/Modal/Procedure model component/Step';
import Decision from '../../Components/Modal/Procedure model component/Decision';
import Diagram from '../../Components/Modal/Procedure model component/Diagram';
import Modal from 'react-modal';
import ProcedurePrev from '../../Components/Modal/Procedure model component/ProcedurePrev';

const EditProcedure = () => {
  const dispatch = useDispatch();
  const {
    isCreating,
    isCreated,
    isFailed,
    procedures,
    procedure,
    isGotProcedure,
  } = useSelector(
    state => ({
      procedure: state.Procedure.procedure,
      isGotProcedure: state.Procedure.isGotProcedure,
    }),
    shallowEqual
  );
  const [procedureName, setProcedureName] = useState('');
  const [previewModel, setPreviewModel] = useState(false);
  const [formData, setFormData] = useState([
    {
      id: `step-${1}`,
      formToggle: true,
      tableOfContent: '',
      information: '',
      decisions: [
        {
          name: '',
          textContent: '',
          link: '',
        },
      ],
      images: [
        {
          name: '',
          src: '',
        },
      ],
      diagrams: [
        {
          name: '',
          src: '',
        },
      ],
    },
  ]);
  const [images, setImages] = useState([]);
  const [diagrams, setDiagrams] = useState([]);
  useEffect(() => {
    if (isGotProcedure) {
      const newForm = [];
      procedure.steps.forEach((step, index) => {
        newForm.push({
          id: `Step-${index + 1}`,
          formToggle: true,
          tableOfContent: step.tableOfContent,
          information: step.information,
          decisions: step.decisions.map((_dec, _index) => {
            return {
              name: _dec.name,
              textContent: _dec.textContent,
              link: _dec.link,
            };
          }),
          images: step.images.map((_img, _index) => {
            return {
              name: _img.name,
              src: `${process.env.REACT_APP_URL}/public/${_img.name}`,
            };
          }),
          diagrams: step.diagrams.map((_dia, _index) => {
            return {
              name: _dia.name,
              src: `${process.env.REACT_APP_URL}/public/${_dia.name}`,
            };
          }),
        });
      });
      setProcedureName(procedure?.name);
      setFormData(newForm);
      dispatch(ResetProcedure());
    }
  }, [isGotProcedure]);
  function closeModal() {
    setFormData([
      {
        id: `step-${1}`,
        formToggle: true,
        tableOfContent: '',
        information: '',
        decisions: [
          {
            name: '',
            textContent: '',
            link: '',
          },
        ],
        images: [
          {
            name: '',
            src: '',
          },
        ],
        diagrams: [
          {
            name: '',
            src: '',
          },
        ],
      },
    ]);
    //   onClose();
  }
  const formToggle = (_index, state) => {
    const updated = formData.map((field, index) =>
      index === _index ? { ...field, formToggle: state } : field
    );
    setFormData(updated);
  };

  const addForm = () => {
    const newField = {
      id: `step-${formData.length + 1}`,
      formToggle: true,
      tableOfContent: '',
      information: '',
      decisions: [
        {
          name: '',
          textContent: '',
          link: '',
        },
      ],
      images: [
        {
          name: '',
          src: '',
        },
      ],
      diagrams: [
        {
          name: '',
          src: '',
        },
      ],
    };
    setFormData(prev => [...prev, newField]);
  };

  const addSubField = _index => {
    const _new = formData.map((f, index) =>
      index === _index
        ? { ...f, decisions: [...f.decisions, { textContent: '', link: '' }] }
        : f
    );
    setFormData(_new);
  };

  const handleInput = (e, id) => {
    const updated = formData.map((field, index) =>
      index === id ? { ...field, [e.target.name]: e.target.value } : field
    );
    setFormData(updated);
    // console.log(updated);
  };
  const handleEditor = (e, index) => {
    const updated = formData.map((field, _index) =>
      _index === index ? { ...field, information: e } : field
    );
    setFormData(updated);
  };
  const handleInsideInput = (e, __index, index2) => {
    const _target = formData.find((f, index) => index === __index);
    const _updated = _target.decisions.map((p, _index) =>
      _index === index2 ? { ...p, [e.target.name]: e.target.value } : p
    );
    _target.decisions = _updated;
    const __updated = formData.map((d, i) =>
      i === __index ? { ...d, decisions: [..._target.decisions] } : d
    );
    setFormData(__updated);
  };

  const saveImages = (e, _index, _id) => {
    const file = e.target.files;
    let _files = [];
    for (const key in Array.from(file)) {
      _files.push({
        name: file[key].name,
        src: URL.createObjectURL(file[key]),
      });
      setImages(prev => [...prev, file[key]]);
    }
    const updated = formData.map((field, index) =>
      index === _index ? { ...field, images: _files } : field
    );
    setFormData(updated);
  };

  const saveDiagrams = (e, _index, _id) => {
    const file = e.target.files;
    let _files = [];
    for (const key in Array.from(file)) {
      _files.push({
        name: file[key].name,
        src: URL.createObjectURL(file[key]),
      });
      setDiagrams(prev => [...prev, file[key]]);
    }
    const updated = formData.map((field, index) =>
      index === _index ? { ...field, diagrams: _files } : field
    );
    setFormData(updated);
  };
  const deleteStep = _index => {
    if (formData.length !== 1) {
      const updated = formData.filter((field, index) => index !== _index);
      setFormData(updated);
    }
  };
  const onDeleteImage = (stepIndex, imgIndex) => {
    const step = formData.find((field, index) => index === stepIndex);
    const _images = step.images.filter((_img, index) => index !== imgIndex);
    step.images = _images;
    const _updatedStep = formData.map((field, index) =>
      index === stepIndex ? { ...field, images: [...step.images] } : field
    );
    setFormData(_updatedStep);
  };
  const onDeleteDiagrams = (stepIndex, diaIndex) => {
    const step = formData.find((field, index) => index === stepIndex);
    const _diagram = step.diagrams.filter((_dia, index) => index !== diaIndex);
    step.diagrams = _diagram;
    const _updatedStep = formData.map((field, index) =>
      index === stepIndex ? { ...field, diagrams: [...step.diagrams] } : field
    );
    setFormData(_updatedStep);
  };
  const submit = async () => {
    try {
      const _formData = new FormData();
      _formData.append('formData', JSON.stringify(formData));
      _formData.append('name', procedureName);
      images.forEach(_img => {
        _formData.append('images', _img);
      });
      diagrams.forEach(_dia => {
        _formData.append('diagrams', _dia);
      });
      dispatch(RequestOfCreatingProcedure());
      const { status, data } = await api.patch(
        `/procedure/procedure-update/${procedure?._id}`,
        _formData
      );
      if (status === 201) {
        toast.success('Procedure updated successfully');
        //   closeModal();
        dispatch(ProcedureUpdateSuccess(data.procedureUpdate));
      }
    } catch (error) {
      // closeModal();
      dispatch(CreateProcedureFailed());
      console.log(error.message);
    }
  };
  return (
    <Layout heading={'Edit Procedure'}>
      <div className="w-[100%]">
        {/* <div className="flex justify-between  mx-5 my-3">
            <h1 className="text-2xl font-semibold">Create Procedure</h1>
            <button onClick={closeModal}>
              <IoMdCloseCircleOutline size={20} />
            </button>
          </div> */}
        <hr />
        <div className="procedure-info-prev flex m-2 h-[70vh] ">
          <div className="procedure-info-heading w-[100vw] h-[68vh] overflow-auto">
            <p className="text-xl font-medium">Procedure Information:</p>
            <div className="flex flex-col">
              <label>Procedure Name:*</label>
              <input
                required
                type="text"
                placeholder="Enter Procedure Name"
                className="w-[50%] h-[35px] border border-black"
                name={'procedureName'}
                value={procedureName}
                onChange={e => setProcedureName(e.target.value)}
              />
            </div>
            <div className="procinfo-main">
              <div className="1stbox h-auto m-2">
                <div className="step-h flex justify-between m-1">
                  <p className="flex font-semibold  ">
                    steps
                    <div className="svg mt-1" style={{ color: '#fe104d' }}>
                      <FaStar size={10} />
                    </div>
                  </p>
                  <button
                    className="flex place-content-center bg-white rounded-md text-sm 
  h-6 w-24 "
                    style={{ border: '2px solid #eceff4' }}
                    onClick={addForm}
                  >
                    Add new step
                  </button>
                </div>
                {formData.map((field, index) => (
                  <>
                    <div
                      style={{
                        height: '2vh',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        textTransform: 'capitalize',
                      }}
                    >
                      {field.id}
                      <IoMdCloseCircleOutline
                        size={20}
                        color={'red'}
                        cursor={'pointer'}
                        onClick={() => deleteStep(index)}
                      />
                    </div>
                    <div className="feild">
                      <div
                        onClick={() => formToggle(index, !field.formToggle)}
                        className=" cursor-pointer input flex  justify-between  mt-0.5 px-5 border-2 rounded-lg"
                      >
                        <div
                          className="text-place"
                          style={{ color: '#eceff4' }}
                        >
                          click dropdown to add steps
                        </div>
                        <div className="arrow mt-1.5">
                          <FaArrowDownLong />
                        </div>
                      </div>
                      {/* extendid div of steps */}
                      {/* {addstep && ( */}
                      {field.formToggle && (
                        <>
                          <Step
                            field={field}
                            index={index}
                            handleInput={handleInput}
                            handleEditor={handleEditor}
                            saveImages={saveImages}
                            onDeleteImage={onDeleteImage}
                          />

                          {/* )} */}
                          <div className="2ndbox h-auto m-2">
                            <div className="step-h flex justify-between m-1">
                              <p className="flex  font-semibold">
                                Decisions
                                <div
                                  className="svg mt-1"
                                  style={{ color: '#fe104d' }}
                                >
                                  <FaStar size={10} />
                                </div>
                              </p>
                              <button
                                className="flex place-content-center bg-white rounded-md text-sm 
  h-6 w-32 "
                                style={{ border: '2px solid #eceff4' }}
                                onClick={() => addSubField(index)}
                              >
                                Add new decision
                              </button>
                            </div>
                            <div
                              // onClick={adddecisiondiv}
                              className=" cursor-pointer input flex  justify-between mt-0.5  px-5 border-2 rounded-lg"
                            >
                              <div
                                className="text-place"
                                style={{ color: '#eceff4' }}
                              >
                                click dropdown to add decision
                              </div>
                              <div className="arrow mt-1.5">
                                <FaArrowDownLong />
                              </div>
                            </div>
                            {/* {adddecision && ( */}
                            {field.decisions.map((_field, _index) => (
                              <>
                                <Decision
                                  _field={_field}
                                  _index={_index}
                                  index={index}
                                  handleInsideInput={handleInsideInput}
                                  // funstioninput={handledecisionInputChange}
                                  // valuedec={DecisioninputValue}
                                  // linkfun={handledecisionlinkInputChange}
                                  // linkval={DecisionlinkinputValue}
                                />
                              </>
                            ))}
                            {/* )} */}
                          </div>

                          <div className="3rdbox h-auto m-2">
                            <div className="step-h flex justify-between">
                              <p className="flex  font-semibold">
                                Diagram
                                <div
                                  className="svg mt-1"
                                  style={{ color: '#fe104d' }}
                                >
                                  <FaStar size={10} />
                                </div>
                              </p>
                            </div>
                            <div
                              // onClick={adddiagramdiv}
                              className=" cursor-pointer input flex  justify-between mx-1  px-5 border-2 rounded-lg pointer"
                            >
                              <div
                                className="text-place"
                                style={{ color: '#eceff4' }}
                              >
                                click dropdown to add diagram
                              </div>
                              <div className="arrow mt-1.5">
                                <FaArrowDownLong />
                              </div>
                            </div>
                            {/* {adddiagram && ( */}
                            <>
                              <Diagram
                                field={field}
                                index={index}
                                saveDiagrams={saveDiagrams}
                                onDeleteDiagrams={onDeleteDiagrams}
                              />
                            </>
                            {/* )} */}
                          </div>
                        </>
                      )}
                    </div>
                  </>
                ))}
              </div>
              {/* second box  of desicion */}

              {/* 3rd box */}
            </div>
          </div>
          {/* <div className="proc ">
              <ProcedurePrev formData={formData} />
            </div> */}
        </div>
        <div className="submit-btn flex justify-between w-[80vw]">
          {/* <div className="dot bg-white">.</div> */}
          <div className="btn flex justify-start items-center gap-3">
            <button
              className="h-[30px] w-[100px] ml-5 bg-[#fe104d] 
              border border-[#fe104d]
               focus:outline 
               focus:transition-all
                outline-[#fe104d] 
                text-white 
                text-center 
                cursor-pointer
                rounded-md 
                "
              onClick={submit}
            >
              Update
            </button>
            <button
              onClick={() => setPreviewModel(true)}
              className="h-[30px] w-[100px]
             border
              border-[#fe104d]
               text-black 
               text-center
                cursor-pointer 
                focus:outline 
                focus:transition-all
                 outline-[#fe104d]
                 rounded-md
                 "
            >
              Preview
            </button>
            {/* <Pinkbtn pbtntext="save" /> */}
          </div>
        </div>
      </div>
      <Modal
        isOpen={previewModel}
        onRequestClose={() => setPreviewModel(false)}
        style={{
          content: {
            height: '80vh',
            width: '85vw',
            transform: 'translate(10%,10%)',
            // overflow: "hidden",
            overflow: 'overFlowY',
            overFlowX: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        }}
      >
        <div className="h-[100%] w-[100%] flex flex-col">
          <div className="h-[5vh] w-[100%] flex justify-end">
            <button
              onClick={() => setPreviewModel(false)}
              className="h-[30px] w-[100px] ml-5 bg-[#fe104d] 
           border border-[#fe104d]
            focus:outline 
            focus:transition-all
             outline-[#fe104d] 
             text-white 
             text-center 
             cursor-pointer
             rounded-md 
             "
            >
              Close
            </button>
          </div>
          <ProcedurePrev formData={formData} />
        </div>
      </Modal>
    </Layout>
  );
};

export default EditProcedure;
